import React from "react";
import { Container, Section, PageHero, Card, Eyebrow, CTABand, SectionTitle } from "@/components/ui-bits/Primitives";
import { SERVICES, IMAGES } from "@/lib/site-data";
import { CheckCircle2 } from "lucide-react";

export default function Services() {
    return (
        <div data-testid="services-page">
            <PageHero
                kicker="Solutions"
                title="Turnkey EV charging infrastructure."
                lead="DC Fast Charging, Level 2, full site development, and 24/7 operations — engineered and operated by M-Class."
                image={IMAGES.heroFastCharging}
            />

            {SERVICES.map((s, i) => {
                const Icon = s.icon;
                const flip = i % 2 === 1;
                return (
                    <Section key={s.id} id={s.id} className={i === 0 ? "" : "border-t border-white/5"}>
                        <Container>
                            <div className={`grid grid-cols-1 lg:grid-cols-12 gap-12 items-center ${flip ? "lg:[&>*:first-child]:order-2" : ""}`}>
                                <div className="lg:col-span-5">
                                    <Eyebrow className="mb-4">{s.kicker}</Eyebrow>
                                    <h2 className="font-heading font-medium text-white text-3xl md:text-5xl tracking-tight leading-[1.05]"><Icon className="inline w-8 h-8 text-electric-400 mr-2 mb-2" strokeWidth={1.5} />{s.title}</h2>
                                    <p className="mt-6 text-slate-400 text-lg leading-relaxed">{s.copy}</p>
                                    <ul className="mt-8 space-y-3">
                                        {s.bullets.map((b) => (
                                            <li key={b} className="flex items-start gap-3 text-slate-300">
                                                <CheckCircle2 className="w-5 h-5 text-electric-400 mt-0.5 shrink-0" />
                                                <span>{b}</span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="lg:col-span-7">
                                    <div className="relative aspect-[5/4] overflow-hidden">
                                        <img src={[IMAGES.heroFastCharging, IMAGES.truckCharging, IMAGES.apartment, IMAGES.blueprint, IMAGES.chargingPark, IMAGES.marina, IMAGES.airport][i]} alt={s.title} className="w-full h-full object-cover" />
                                        <div className="absolute inset-0 bg-gradient-to-tr from-ink-900/70 via-transparent to-transparent" />
                                    </div>
                                </div>
                            </div>
                        </Container>
                    </Section>
                );
            })}

            <CTABand title="Have a site or program in mind?" subtitle="Tell us about your project — we'll respond within one business day with a feasibility outline." />
        </div>
    );
}
